<template>
  <div class="computer-modules">


    <div v-if="modalOpened" class="madalbackground" @click="closeModals"></div>
    <!--</transition>-->
    <!--edit profile and new user forced-->

    <div class="container">
      <transition tag="div" name="slideUp">
        <div class="mandatory-modal" v-if="tornomentModal">

          <div class="image-box d-flex justify-content-center">
            <img :src="image">
          </div>

          <div class="desc text-center">
            <p class="font-bold" v-html="this.name"></p>
            <p>انتخاب دوره مسابقات</p>
          </div>

          <div class="input-container d-flex flex-column">


            <router-link v-for="itemMain in gtid" :to="{name: 'tornoment-single',params: { id:itemMain.id,background:background,item:item,final:finalImg}}" tag="button" class="btn buy-ticket active mt-2">
              {{ itemMain.name }}
            </router-link>

          </div>

        </div>
      </transition>
    </div>


    <div class="computer-game-items d-flex justify-content-center flex-column p-4">

      <div class="mb-4 item-computer d-flex flex-column" v-for="data in lists" @click="openTorModal(data)">

        <img :src="`${data.url}`">

      </div>

    </div>

  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      lists: [
        {
          url:"https://kishoto.ir/images/fifalogo.png",
          name:"تورنومنت FIFA",
          background:"https://kishoto.ir/images/fifa_t_back.jpg",
          item:"https://kishoto.ir/images/ball.png",
          finalImg:"https://kishoto.ir/images/final.png",
          gtid:[
            {
              id:5,
              name:"دوره اول"
            },
            {
              id:6,
              name:"دوره دوم"
            }
          ]
        },
        {
          url:"https://kishoto.ir/images/peslogo.jpg",
          name:"تورنومنت PES",
          background:"https://kishoto.ir/images/pes_t_back.jpg",
          item:"https://kishoto.ir/images/ball.png",
          finalImg:"https://kishoto.ir/images/final.png",
          gtid:[
            {
              id:3,
              name:"دوره اول"
            },
            {
              id:4,
              name:"دوره دوم"
            }
          ]
        },
        {
          url:"https://kishoto.ir/images/tekkenlogo.jpg",
          name:"تورنومت TEKKEN",
          background:"https://kishoto.ir/images/tekken_t_back.jpg",
          item:"https://kishoto.ir/images/skull.png",
          finalImg:"https://kishoto.ir/images/final-skull.png",
          gtid:[
            {
              id:7,
              name:"دوره اول"
            },
            {
              id:8,
              name:"دوره دوم"
            }
          ]
        },
      ],
      modalOpened:false,
      tornomentModal:false,

      name:null,
      image:null,
      item:null,
      finalImg:null,
      background:null,
      gtid:null,
    };
  },
  created(){

  },
  computed: {

  },
  methods: {
    closeModals() {
      this.modalOpened = false;
      this.tornomentModal = false;
    },
    openTorModal(data){
      this.tornomentModal = true;
      this.modalOpened = true;

      this.name = data.name;
      this.image = data.url;
      this.gtid = data.gtid;

      this.background = data.background;
      this.finalImg = data.finalImg;
      this.item = data.item;
    },
  }
};
</script>

<style lang="scss" scoped>
.computer-modules {
  background-image: url("~@/assets/img/bg/tornoments.jpg");
  width: 100%;
  min-height: 100%;
  height: 100vh;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  /*  background: url("~@/assets/img/bg/fifa_t_back.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;*/

  .mandatory-modal {
    position: fixed;
    height: 410px;
    width: 100%;
    background-color: #fff;
    //border-radius: 10px;
    //transform: translate(-50%, -50%);
    padding: 0px !important;
    direction: rtl;
    z-index: 2;
    overflow-y:scroll;
    overflow-x:hidden;
    //border: 1px dashed #80808033;
    bottom: 0;
    left: 0;
    .title {
      width: 100%;
      height: 3px;
      /* background-color: blue; */
      /* margin-top: 40px; */
      text-align: center;
      /* position: relative; */
      margin-bottom: 51px;
      p {
        padding: 10px 20px;
        background-color: white;
        font-family: "sansb";
        font-size: 20px;
        font-weight: bold;
      }
    }
    .desc {
      width: 100%;
      padding: 0 20px;
      text-align: right;
      margin-top: 20px;
      padding-bottom: 10px;
      p {
        font-family: "sans";
        font-size: 17px;
        line-height: 28px;
        white-space: pre-line;
      }
    }
    .image-box{
      img{
        width: 100%;
        height: 180px;
      }
    }
    .input-container{
      //position: fixed;
      bottom: 0px;
      height: auto;
      background: #ffffff;
      width: 100%;
      display: flex;
      flex-direction: column;
      //justify-content: space-around;
      padding: 0px 0px 7px 9px;
      justify-content: center;
      margin: 0 auto;
      align-items: center;

      .buy-ticket.disactive{
        background: #37474f;
        color:#ffffff;
        width: 70%;
        padding: 9px;
        margin-bottom: 5px;
      }
      .buy-ticket.active{
        background: #37474f;
        color:#ffffff;
        width: 70%;
        padding: 9px;
      }
    }
  }

  .title-container-box{
    background: #ffffff;
    padding: 15px 15px 40px 15px;
    width: 92%;
    border-radius: 0 0 20px 20px;
    margin-bottom: 33px;
    .image-box{
      img{
        width: 130px;
        height: 130px;
        border-radius: 50%;
        margin-bottom: 20px;
        border: 2px solid #9e9e9e;
        box-shadow: 1px 1px 14px 2px #9e9e9ea1;
      }
    }

    .computer-title{
      h3{

      }
      p{
        color:#757575;
      }
    }
  }

  .computer-game-items{
    .item-computer{
      padding: 14px 14px 5px 14px;
      border-radius: 30px;
      img{
        border-radius: 30px;

      }
    }
  }

  .madalbackground{
    width: 100%;
    height: inherit;
    background: #0000006e;
    position: fixed;
    z-index: 1;
  }
}
</style>
